import React from 'react';
import styled from 'styled-components';
import {Select} from 'antd';
import {useOutlet} from 'reconnect.js';
import NavLink from '../NavLink';
import * as NavUtil from '../../Utils/NavUtil';
import * as AppActions from '../../AppActions';
import useDetectDimension from '../../Hooks/useDetectDimension';
const Config = require('../../../data.json');

const iconSize = 24;
const L = AppActions.L;
const F = AppActions.F;

export default function SiteFooter(props) {
  useOutlet('footerConfig');
  const footerConfig = NavUtil.getFooterConfig(props);
  const navItems = NavUtil.getFooterNavItems(props);
  const [locale, setLocale] = useOutlet('locale');
  const [dimension] = useOutlet('dimension');

  return (
    <Wrapper id="rev-SiteFooter" rwd={dimension.rwd}>
      <div className="content">
        <div className="footer-items">
          <div className="title">
            <span>{L('store_info')}</span>
          </div>
          {footerConfig.contact_addr && (
            <div className="addr">{F(footerConfig, 'contact_addr')}</div>
          )}
          {footerConfig.contact_phone && (
            <div className="phone">{footerConfig.contact_phone}</div>
          )}
          {footerConfig.contact_time && (
            <div className="time">{footerConfig.contact_time}</div>
          )}
        </div>

        <div className="footer-items">
          <div className="title">
            <span>{L('contact_us')}</span>
          </div>
          <div>
            <span className="uppercase">
              {L('customer_order_question')} :{' '}
              <a
                target="_blank"
                href={`mailto:${
                  footerConfig.contact_email || 'contact@hishop.com'
                }`}
                rel="noreferrer">
                {footerConfig.contact_email || 'contact@hishop.com'}
              </a>
            </span>
          </div>
          <div>
            <span className="uppercase">
              {L('business_coop')} :{' '}
              <a
                target="_blank"
                href={`mailto:service.season@gmail.com`}
                rel="noreferrer">
                service.season@gmail.com
              </a>
            </span>
          </div>
        </div>

        <div className="footer-items services">
          <div className="title">
            <span>{L('customer_service')}</span>
          </div>
          {navItems.map((navItem, idx) => {
            return (
              <NavLink key={idx} to={navItem.path}>
                <span className="uppercase">{F(navItem, 'name')}</span>
              </NavLink>
            );
          })}
        </div>

        <div className="left">
          <div className="social-items">
            {footerConfig.social_fb && (
              <a href={footerConfig.social_fb} target="_blank" rel="noreferrer">
                <svg width={iconSize} height={iconSize}>
                  <use xlinkHref="/images/icon-facebook.svg#_圖層_2" />
                </svg>
              </a>
            )}

            {footerConfig.social_ig && (
              <a href={footerConfig.social_ig} target="_blank" rel="noreferrer">
                <svg width={iconSize} height={iconSize}>
                  <use xlinkHref="/images/icon-instagram.svg#_圖層_2" />
                </svg>
              </a>
            )}

            {footerConfig.social_line && (
              <a
                href={footerConfig.social_line}
                target="_blank"
                rel="noreferrer">
                <svg width={iconSize} height={iconSize}>
                  <use xlinkHref="/images/icon-line.svg#_圖層_2" />
                </svg>
              </a>
            )}
          </div>
          <div className="lang-selector">
            <Select
              value={locale.lang}
              onChange={(nextLang) => setLocale({lang: nextLang})}>
              <Select.Option value="tw">中文</Select.Option>
              <Select.Option value="en">English</Select.Option>
            </Select>
          </div>
          {footerConfig.company_name && (
            <div className="company-name">{footerConfig.company_name}</div>
          )}
          {footerConfig.gui_number && (
            <div className="gui-number">
              {L('uni_no')} {footerConfig.gui_number}
            </div>
          )}
          <div className="copyright">
            {footerConfig.copyright || '2021 HiShop Powered By Revteltech'}
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-color: var(--background-reverse-color);

  & > .content {
    max-width: var(--contentMaxWidth);
    padding: 50px
      ${(props) =>
        props.rwd === 'desktop' ? 0 : props.rwd === 'tablet' ? 50 : 20}px;
    margin: 0 auto;
    color: var(--text-reverse-color);
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    & > .footer-items {
      flex: 1 0 250px;
      & > * {
        margin-bottom: 6px;
        font-size: 0.9rem;
        display: flex;
        align-items: center;

        &.title {
          margin-bottom: 8px;
          & > span {
            border-bottom: 1px solid var(--text-reverse-color);
            &:first-letter {
              text-transform: uppercase;
            }
          }
        }
      }

      & a {
        color: var(--text-reverse-color);
      }

      & .uppercase:first-letter {
        text-transform: uppercase;
      }
    }

    & > .footer-items.services {
      flex: 0 1 100px;
    }

    & > .left {
      flex: 1 0 250px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-between;

      & > .social-items {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;
        margin-bottom: 10px;

        & > a {
          margin-left: 30px;
          color: var(--secondColor);
          fill: var(--secondColor);
        }
        & > a:hover {
          color: var(--text-reverse-color);
          fill: var(--text-reverse-color);
        }
      }

      & > .lang-selector {
        margin-bottom: 10px;
        & .ant-select {
          color: var(--text-reverse-color);
        }
        & .ant-select-selector {
          background-color: var(--background-reverse-color);
          border: solid 1px var(--text-reverse-color);
        }
        & .ant-select-focused .ant-select-selector {
          border: solid 1px var(--text-reverse-color);
        }
        & .ant-select-arrow {
          color: var(--text-reverse-color);
        }
      }

      & > .company-name,
      .gui-number {
        font-size: 12px;
        &:first-letter {
          text-transform: uppercase;
        }
      }

      & > .copyright {
        width: 100%;
        font-size: 12px;
        text-align: right;
      }
    }
  }
`;
